export default __webpack_public_path__ + "static/media/burrata.28e5ecc9.jpg";